import { useEffect } from 'react'
import HercodeLandingPage from './pages/page'

const HEADER_OFFSET_PX = 80
const SCROLL_DURATION_MS = 100
const RESPECT_REDUCED_MOTION = true

function smoothScrollTo(targetY: number, durationMs: number) {
  const startY = window.scrollY
  const delta = targetY - startY
  if (delta === 0) return

  const start = performance.now()
  const easeInOutCubic = (t: number) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2

  const step = (now: number) => {
    const elapsed = now - start
    const t = Math.min(1, elapsed / durationMs)
    const eased = easeInOutCubic(t)
    window.scrollTo(0, startY + delta * eased)
    if (t < 1) requestAnimationFrame(step)
  }

  requestAnimationFrame(step)
}

export default function App() {
  useEffect(() => {
    const prefersReducedMotion =
      RESPECT_REDUCED_MOTION &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches

    const onClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null
      const anchor = target?.closest('a[href^="#"]') as HTMLAnchorElement | null
      if (!anchor) return

      const href = anchor.getAttribute('href')
      if (!href || href === '#') return

      const id = href.slice(1)
      const el = document.getElementById(id)
      if (!el) return

      event.preventDefault()

      if (prefersReducedMotion) {
        el.scrollIntoView()
        return
      }

      const rect = el.getBoundingClientRect()
      const targetY = rect.top + window.scrollY - HEADER_OFFSET_PX
      smoothScrollTo(targetY, SCROLL_DURATION_MS)
    }

    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [])

  return <HercodeLandingPage />
}
